import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AdminDashboard from "@/components/AdminDashboard";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [authenticated, setAuthenticated] = useState(
    () => sessionStorage.getItem("admin_auth") === "true"
  );

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === "1diomas_test") {
      sessionStorage.setItem("admin_auth", "true");
      setAuthenticated(true);
      setError("");
    } else {
      setError("Invalid password");
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("admin_auth");
    setAuthenticated(false);
    setPassword("");
  };

  if (authenticated) {
    return <AdminDashboard onLogout={handleLogout} />;
  }

  return (
    <div className="min-h-screen bg-background bg-grid-dots flex items-center justify-center p-4">
      <div className="w-full max-w-sm animate-slide-up">
        <div className="rounded-2xl border border-border/50 bg-card/80 backdrop-blur-xl p-8 shadow-2xl">
          <div className="flex flex-col items-center mb-8">
            <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
              <Lock className="h-6 w-6 text-primary" strokeWidth={1.5} />
            </div>
            <h1 className="font-heading text-2xl font-semibold tracking-tight">
              Admin Access
            </h1>
            <p className="text-muted-foreground text-sm mt-1">
              Enter the admin password to continue
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="admin-password" className="text-sm text-muted-foreground">
                Password
              </Label>
              <Input
                data-testid="admin-password-input"
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                placeholder="Enter admin password"
                className="bg-secondary/50 border-border/50 focus:ring-primary"
                autoFocus
              />
              {error && (
                <p data-testid="admin-login-error" className="text-xs text-destructive">
                  {error}
                </p>
              )}
            </div>
            <Button
              data-testid="admin-login-btn"
              type="submit"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 glow-primary font-medium"
            >
              Unlock Dashboard
            </Button>
          </form>

          <Button
            data-testid="back-to-chat-link"
            variant="ghost"
            onClick={() => navigate("/")}
            className="w-full mt-4 text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4 mr-2" strokeWidth={1.5} />
            Back to Chat
          </Button>
        </div>
      </div>
    </div>
  );
}
